module.exports = __webpack_public_path__ + "static/media/skipid.87c25556.svg";